// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EI-z","twoColumnImage":"FI-z"};